import { MANUAL_CHANNELS } from "../constants.ts";
import { getRegisterAdminRole } from "../auth.ts";
import type { Channel, Ticket } from "../types.ts";

const FULL_CHANNEL_EDIT_ROLES = new Set(["super", "manager", "ops_manager"]);
const WRITE_ROLES = new Set([
  "super", "manager", "sales_admin", "factory_manager", "partner_manager", "ops_manager", "support",
]);

/** manager 以上は全区分変更可。support 等は device_monitor→手動チャネルの再分類のみ。 */
export function canEditTicketChannel(ticket: Ticket): boolean {
  const role = getRegisterAdminRole() || "";
  if (FULL_CHANNEL_EDIT_ROLES.has(role)) return true;
  return WRITE_ROLES.has(role) && ticket.channel === "device_monitor";
}

/** 区分セレクトの選択肢（現在が機体監視なら現在値を先頭に表示） */
export function channelSelectOptions(current: Channel) {
  const manual = MANUAL_CHANNELS;
  if (current === "device_monitor") {
    const cur = { key: "device_monitor" as const, label: "機体監視（現在）", hint: "" };
    return [cur, ...manual];
  }
  return manual;
}
